import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=45cd64e8&scoped=true&"
import script from "./ImageUploader.vue?vue&type=script&lang=js&"
export * from "./ImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploader.vue?vue&type=style&index=0&id=45cd64e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cd64e8",
  null
  
)

export default component.exports